import { buildGlobalCssWithSectionStyleGenerators } from '../../utils/build-global-css/build-global-css';
import { buildCssMobile } from './build-css-mobile';
export function buildCss(_a) {
    var css = _a.css, breakPoint = _a.breakPoint, composerData = _a.composerData, experiments = _a.experiments, sections = _a.sections, buildForMobile = _a.buildForMobile;
    return [
        ".so-link-href {text-decoration: none;}\n    ",
        buildForMobile ? buildCssMobile(css).trim() : '',
        buildGlobalCssWithSectionStyleGenerators({
            breakPoint: breakPoint,
            composerData: composerData,
            css: css,
            experiments: experiments,
            sections: sections,
            buildForMobile: buildForMobile,
        }).trim(),
    ].join('');
}
//# sourceMappingURL=build-css.js.map